import axios, { AxiosResponse } from "axios";
import { ArrayFromEnvelope, configService, ObjectFromEnvelope } from "./config.service";
import { Duty } from "../models/duties";
import { convertDateOnlyToUtc } from "../utils/dateUtils";

class DutiesService {
  getConflictsOnDuties(from: Date, to: Date, employeeId: number | null = null): Promise<any[]> {
    const params: any = {
      start_date: convertDateOnlyToUtc(from),
      end_date: convertDateOnlyToUtc(to)
    };
    if (employeeId) {
      params.employee_id = employeeId;
    } else {
      params.institution_id = configService.institutionId();
    }
    return new Promise((resolve, reject) => {
      axios
        .get<any[]>(configService.personaleOrAdminUrl("duties/get_conflicts_on_duties.json"), {
          params: params
        })
        .then((response: AxiosResponse) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async fetchDuties(fra: Date, tilOgMed: Date): Promise<Duty[]> {
    return new Promise((resolve, reject) => {
      const utcFra: string = convertDateOnlyToUtc(fra);
      const utcTilOgMed: string = convertDateOnlyToUtc(tilOgMed);

      axios
        .get<Duty[]>(configService.personaleOrAdminUrl("duties.json"), {
          params: {
            institution_id: configService.institutionId(),
            end_date: utcTilOgMed,
            start_date: utcFra
          }
        })
        .then((response: AxiosResponse) => {
          resolve(Duty.fromJSONArray(ArrayFromEnvelope<Duty>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async fetchDutiesByEmployeeId(
    employeeId: number,
    startDate: Date,
    endDate: Date
  ): Promise<Duty[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<Duty[]>(configService.APIInstitutionUrl("duties.json"), {
          params: {
            employee_id: employeeId,
            start_date: convertDateOnlyToUtc(startDate),
            end_date: convertDateOnlyToUtc(endDate)
          }
        })
        .then((response: AxiosResponse) => {
          resolve(Duty.fromJSONArray(ArrayFromEnvelope<Duty>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async fetchDutiesByEventId(eventId: number): Promise<Duty[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<Duty[]>(configService.APIInstitutionUrl("duties.json"), {
          params: {
            event_id: eventId
          }
        })
        .then((response: AxiosResponse) => {
          resolve(Duty.fromJSONArray(ArrayFromEnvelope<Duty>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async createDuty(duty: Duty): Promise<Duty> {
    return new Promise((resolve, reject) => {
      axios
        .post<Duty>(configService.APIInstitutionUrl("duties.json"), duty.convertToPostObject())
        .then((response: AxiosResponse) => {
          resolve(Duty.fromJSON(ObjectFromEnvelope<Duty>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }
  async updateDuty(duty: Duty): Promise<Duty> {
    return new Promise((resolve, reject) => {
      axios
        .put<Duty>(
          configService.APIInstitutionUrl("duties/" + duty.id + ".json"),
          duty.convertToPutObject()
        )
        .then((response: AxiosResponse) => {
          resolve(Duty.fromJSON(ObjectFromEnvelope<Duty>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }
  async deleteDuty(dutyId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete<Duty>(configService.APIInstitutionUrl("duties/" + dutyId + ".json"))
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  }
}

export const dutiesService: DutiesService = new DutiesService();
